import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import { getUIVersion } from 'lib/uiVersion'

import Sites from 'pages/Sites'
import SitesClassic from 'pages/Sites/Sites.classic'

// Read once at module load -- version never changes without a full page reload
const IS_CLASSIC_UI = getUIVersion() === 'classic'

const sitesSearchSchema = z.object({
  tab: z.enum(['list', 'map']).optional().default('list'),
})

const sitesSearchDefaults = { tab: 'list' } as const

export const Route = createFileRoute('/_auth/sites/')({
  component: IS_CLASSIC_UI ? SitesClassic : Sites,
  validateSearch: zodValidator(sitesSearchSchema),
  search: {
    middlewares: [stripSearchParams(sitesSearchDefaults)],
  },
})
